import HallowButton from "../../components/customComponents/HallowButton";
import AdditionalInformationModal from "../../components/Modal/AdditionalInformationModal";
import { useDispatch, useSelector } from "react-redux";
import { setAdditionalInformationModal } from "../../reducer/modalReducer";
import { RootState } from "../../app/store";
import { useEffect, useState } from "react";
import { useOwnProfile } from "../../hooks/useProfile";

export default function RegistrationAdditionalInformationSection() {
  const { professionalLicenseNumber } = useSelector(
    (state: RootState) => state.registration
  );
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  // State to hold the edited license number
  const [editedLicenseNumber, setEditedLicenseNumber] = useState<string>(
    professionalLicenseNumber || ""
  );

  const handleEditButtonClick = () => {
    dispatch(setAdditionalInformationModal(true));
  };

  const { getOwnProfile } = useOwnProfile();

  useEffect(() => {
    setLoading(true);
    const getLicenseNumber = async () => {
      const response = await getOwnProfile({ setLoading });
      if (response && response.professionalLicenseNumber) {
        setEditedLicenseNumber(response.professionalLicenseNumber);
      }
      setLoading(false);
    };

    getLicenseNumber();
  }, []);

  useEffect(() => {
    console.log(
      "Updating editedLicenseNumber with professionalLicenseNumber:",
      professionalLicenseNumber
    );
    setEditedLicenseNumber(professionalLicenseNumber || "");
  }, [professionalLicenseNumber]);

  return (
    <div className={Classname.container}>
      <AdditionalInformationModal />
      <div className={Classname.flexBetween}>
        <div className="font-semibold mb-3">Additional Information</div>
        <HallowButton label="Edit" onClick={handleEditButtonClick} />
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>Professional license number</div>
        {/* Display logic */}
        {editedLicenseNumber ? (
          <div>{editedLicenseNumber}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
    </div>
  );
}

const Classname = {
  container: "bg-white pb-10 rounded-md p-2 h-fit gap-3 flex flex-col lg:px-10",
  flexBetween: "flex justify-between mt-5",
  title: "font-bold w-56",
  listContainer: "flex lg:gap-32 flex-col lg:flex-row",
  unspecified: "text-red-500 ",
};
